import { RosterStatus } from '__generated__/graphql'
import { codec } from './useUrlState'

export const DEFAULT_STATUSES = [
    RosterStatus.Active,
    RosterStatus.Opportunistic,
    RosterStatus.OnHold,
]

export type RosterFilterState = {
    statuses: string[]
    type: string | undefined
    name: string | undefined
    quickSearch: string | undefined
    companyIds: string[]
    createdByUserIds: string[]
    createdAtGte: string | undefined
    createdAtLte: string | undefined
    internalUserIds: string[]
    industryIds: string[]
    sectorIds: string[]
    geoLocationIds: string[]
    geoLocationText: string[]
    titleIds: string[]
    consultants: string | undefined
    fundSizeIds: string[]
    visaStatusIds: string[]
    startDates: string[]
    processStatusIds: string[]
    processStatusGroupIds: string[]
}

export const filterCodec = {
    statuses: codec.stringArray({
        urlKey: 'status',
        defaultValue: DEFAULT_STATUSES,
    }),
    type: codec.string(),
    name: codec.string(),
    quickSearch: codec.string({ urlKey: 'q' }),
    companyIds: codec.stringArray({ urlKey: 'company' }),
    createdByUserIds: codec.stringArray({ urlKey: 'createdBy' }),
    createdAtGte: codec.string({ urlKey: 'createdFrom' }),
    createdAtLte: codec.string({ urlKey: 'createdTo' }),
    internalUserIds: codec.stringArray({ urlKey: 'users' }),
    industryIds: codec.stringArray({ urlKey: 'industry' }),
    sectorIds: codec.stringArray({ urlKey: 'sector' }),
    geoLocationIds: codec.stringArray({ urlKey: 'location' }),
    geoLocationText: codec.stringArray({ urlKey: 'locationText' }),
    titleIds: codec.stringArray({ urlKey: 'title' }),
    consultants: codec.string({ urlKey: 'consultant' }),
    fundSizeIds: codec.stringArray({ urlKey: 'fundSize' }),
    visaStatusIds: codec.stringArray({ urlKey: 'visa' }),
    startDates: codec.stringArray({ urlKey: 'startDate' }),
    processStatusIds: codec.stringArray({ urlKey: 'processStatus' }),
    processStatusGroupIds: codec.stringArray({ urlKey: 'processStatusGroup' }),
}

export const FILTER_KEYS = Object.keys(
    filterCodec
) as (keyof typeof filterCodec)[]

export const defaultFilters = Object.fromEntries(
    FILTER_KEYS.map((k) => [k, filterCodec[k].default])
) as RosterFilterState
